import React from 'react';
import { useSelector } from 'react-redux';
import MasterTitle from './MasterTitle';
import MasterLists from './MasterLists';
import EditMasterDialog from './EditMasterDialog';
import OneLayerMasterImportDialog from './OneLayerMasterImportDialog';
import MasterImportDialog from './MasterImportDialog';
import ImportErrorDialog from './ImportErrorDialog';
import {
  Main,
  Block,
  ListsBlock,
  ListWrapper,
} from './styles/MasterPageStyles';
import createDepthList from './functions/createDepthList';
import { isCompanyAdmin } from '../../lib/tools';

/**
 * タグセット管理ページ。MainPageから呼び出す。
 * ユーザーが所属している企業に紐づくタグセットを表示する。
 * また、タグのインポート（１階層づつ、全階層）、編集、削除を行うことができる
 */
const MasterPage = () => {
  const {
    openEditMasterDialog,
    openOneLayerMasterImportDialog,
    openMasterImportDialog,
    openImportErrorDialog,
    maxDepth,
    currentUserRole,
  } = useSelector(state => ({
    openEditMasterDialog: state.master.openEditMasterDialog,
    openOneLayerMasterImportDialog: state.master.openOneLayerMasterImportDialog,
    openMasterImportDialog: state.master.openMasterImportDialog,
    openImportErrorDialog: state.master.openImportErrorDialog,
    maxDepth: state.master.maxDepth,
    currentUserRole: state.main.innerRole,
  }));

  const depthList = createDepthList(maxDepth);
  const isCompanyAdminUser = isCompanyAdmin(currentUserRole);

  return (
    <Main className="masterPage">
      <Block>
        <MasterTitle isCompanyAdminUser={isCompanyAdminUser} />
        <ListsBlock>
          {depthList.map(depth => (
            <ListWrapper
              key={`masterListWrapper${depth}`}
              currentDepth={depth}
              maxDepth={maxDepth}
            >
              <MasterLists
                currentDepth={depth}
                isCompanyAdminUser={isCompanyAdminUser}
              />
            </ListWrapper>
          ))}
        </ListsBlock>
        {openEditMasterDialog !== 'none' && <EditMasterDialog />}
        {openOneLayerMasterImportDialog && <OneLayerMasterImportDialog />}
        {openMasterImportDialog && <MasterImportDialog />}
        {openImportErrorDialog && <ImportErrorDialog />}
      </Block>
    </Main>
  );
};

export default MasterPage;
